/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_dk_100_107 as Componente_dk_100_107,
  rec_Componente_lk_108_107 as Componente_lk_108_107,
  rec_Componente_uk_117_107 as Componente_uk_117_107,
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_api as api,
  rec_esAdministrador as esAdministrador,
  rec_puedeAccion as puedeAccion,
} from "../../runtime/index.jsx";
export function EquipoUnidad({ unidadId: e, sede: t }) {
  let n = esAdministrador() || puedeAccion(`planner.tareas.ver`, e),
    [r, i] = (0, React.useState)([]),
    [a, o] = (0, React.useState)(!0),
    [s, c] = (0, React.useState)(``),
    l = (0, React.useCallback)(async () => {
      o(!0);
      try {
        (i((await api(`/unidades/${e}/equipo${t ? `?sede=${t}` : ``}`)) ?? []),
          c(``));
      } catch (e) {
        c(e.message);
      } finally {
        o(!1);
      }
    }, [e, t]);
  return (
    (0, React.useEffect)(() => {
      l();
    }, [l]),
    (
      <section
        className={`flex flex-col gap-2`}
        children={[
          <p
            className={`text-sm font-medium text-(--text-h)`}
            children={`Personas`}
          />,
          <EstadoError mensaje={s} onReintentar={l} />,
          a ? (
            <Componente_dk_100_107 />
          ) : r.length === 0 ? (
            <Componente_lk_108_107
              children={`Todavía no hay nadie cargado acá.`}
            />
          ) : (
            <JSXRuntime.Fragment
              children={[
                <ul
                  className={`flex flex-col gap-1.5 sm:hidden`}
                  children={r.map((e) => (
                    <li
                      key={e.usuarioId}
                      className={`rounded-xl border border-(--border) px-3 py-2`}
                      children={[
                        <div
                          className={`flex items-baseline justify-between gap-2`}
                          children={[
                            <span
                              className={`min-w-0 flex-1 truncate text-(--text-h)`}
                              children={e.nombre}
                            />,
                            <span
                              className={`shrink-0 text-xs text-(--text)`}
                              children={[e.avancePromedio, `%`]}
                            />,
                          ]}
                        />,
                        e.cargo && (
                          <p
                            className={`truncate text-xs text-(--text)`}
                            children={[
                              e.cargo,
                              e.unidadNombre ? ` · ${e.unidadNombre}` : ``,
                            ]}
                          />
                        ),
                        <p
                          className={`mt-1 flex flex-wrap gap-x-3 text-xs`}
                          children={[
                            <span
                              className={`text-(--text)`}
                              children={[e.abiertas, ` abiertas`]}
                            />,
                            <span
                              className={
                                e.atrasadas > 0
                                  ? `font-medium text-(--error)`
                                  : `text-(--text)`
                              }
                              children={[e.atrasadas, ` atrasadas`]}
                            />,
                            n && (
                              <span
                                className={`text-(--text)`}
                                children={[e.enRevision, ` en revisión`]}
                              />
                            ),
                            <span
                              className={`text-(--text)`}
                              children={[e.completadas, ` listas`]}
                            />,
                          ]}
                        />,
                      ]}
                    />
                  ))}
                />,
                <div
                  className={`hidden overflow-x-auto sm:block`}
                  children={
                    <table
                      className={`w-full min-w-[460px] text-sm tabular-nums`}
                      children={[
                        <thead
                          children={
                            <tr
                              className={`border-b border-(--border) text-left text-xs text-(--text)`}
                              children={[
                                <th
                                  className={`py-1.5 pr-3 font-normal`}
                                  children={`Persona`}
                                />,
                                <th
                                  className={`py-1.5 pr-3 text-right font-normal`}
                                  children={`Abiertas`}
                                />,
                                <th
                                  className={`py-1.5 pr-3 text-right font-normal`}
                                  children={`Atrasadas`}
                                />,
                                n && (
                                  <th
                                    className={`py-1.5 pr-3 text-right font-normal`}
                                    children={`En revisión`}
                                  />
                                ),
                                n && (
                                  <th
                                    className={`py-1.5 pr-3 text-right font-normal`}
                                    children={`Completadas`}
                                  />
                                ),
                                <th
                                  className={`py-1.5 pr-3 font-normal`}
                                  children={`Avance`}
                                />,
                              ]}
                            />
                          }
                        />,
                        <tbody
                          children={r.map((e) => (
                            <tr
                              key={e.usuarioId}
                              className={`border-b border-(--border)/60`}
                              children={[
                                <td
                                  className={`py-1.5 pr-3`}
                                  children={[
                                    <span
                                      className={`text-(--text-h)`}
                                      children={e.nombre}
                                    />,
                                    e.cargo && (
                                      <span
                                        className={`ml-2 text-xs text-(--text)`}
                                        children={[
                                          e.cargo,
                                          e.unidadNombre
                                            ? ` · ${e.unidadNombre}`
                                            : ``,
                                        ]}
                                      />
                                    ),
                                  ]}
                                />,
                                <td
                                  className={`py-1.5 pr-3 text-right text-(--text-h)`}
                                  children={e.abiertas}
                                />,
                                <td
                                  className={`py-1.5 pr-3 text-right ${e.atrasadas > 0 ? `font-medium text-(--error)` : `text-(--text)`}`}
                                  children={e.atrasadas}
                                />,
                                n && (
                                  <td
                                    className={`py-1.5 pr-3 text-right text-(--text)`}
                                    children={e.enRevision}
                                  />
                                ),
                                n && (
                                  <td
                                    className={`py-1.5 pr-3 text-right text-(--text)`}
                                    children={e.completadas}
                                  />
                                ),
                                <td
                                  className={`py-1.5 pr-3`}
                                  children={
                                    <div
                                      className={`flex items-center gap-2`}
                                      children={[
                                        <Componente_uk_117_107
                                          valor={e.avancePromedio}
                                        />,
                                        <span
                                          className={`text-xs text-(--text)`}
                                          children={[e.avancePromedio, `%`]}
                                        />,
                                      ]}
                                    />
                                  }
                                />,
                              ]}
                            />
                          ))}
                        />,
                      ]}
                    />
                  }
                />,
              ]}
            />
          ),
        ]}
      />
    )
  );
}
